/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DifficultyEnum = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type updateMutationVariables = {|
  id: string,
  serves?: ?string,
  name: string,
  difficulty?: ?DifficultyEnum,
  category?: ?string,
  hotKeep?: ?boolean,
  description?: ?string,
|};
export type updateMutationResponse = {|
  +recipeUpdate: ?{|
    +recipe: ?{|
      +id: string,
      +name: string,
      +picture: ?string,
    |}
  |}
|};
export type updateMutation = {|
  variables: updateMutationVariables,
  response: updateMutationResponse,
|};
*/


/*
mutation updateMutation(
  $id: ID!
  $serves: String
  $name: String!
  $difficulty: DifficultyEnum
  $category: ID
  $hotKeep: Boolean
  $description: String
) {
  recipeUpdate(input: {id: $id, name: $name, category: $category, difficulty: $difficulty, serves: $serves, hotKeep: $hotKeep, description: $description}) {
    recipe {
      id
      name
      picture
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serves",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "difficulty",
    "type": "DifficultyEnum"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "category",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hotKeep",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "category",
            "variableName": "category"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "difficulty",
            "variableName": "difficulty"
          },
          {
            "kind": "Variable",
            "name": "hotKeep",
            "variableName": "hotKeep"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "serves",
            "variableName": "serves"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeUpdatePayload",
    "kind": "LinkedField",
    "name": "recipeUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeNode",
        "kind": "LinkedField",
        "name": "recipe",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "picture",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateMutation",
    "operationKind": "mutation",
    "text": "mutation updateMutation(\n  $id: ID!\n  $serves: String\n  $name: String!\n  $difficulty: DifficultyEnum\n  $category: ID\n  $hotKeep: Boolean\n  $description: String\n) {\n  recipeUpdate(input: {id: $id, name: $name, category: $category, difficulty: $difficulty, serves: $serves, hotKeep: $hotKeep, description: $description}) {\n    recipe {\n      id\n      name\n      picture\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6bcd89bdd024e4a49f946ec6c6dad225';

module.exports = node;
